export default __webpack_public_path__ + "static/media/banco-pichincha.74e7d799.svg";